module.exports = __webpack_public_path__ + "static/media/open-builder-2.06aede99.png";